<ng-container>
  <!-- Actions -->
  <button
    #nodeActionsTrigger="matMenuTrigger"
    app-button
    data-test="nodeActionsTrigger"
    buttonSize="xsmall"
    [buttonTheme]="theme"
    [matMenuTriggerFor]="nodeActions"
    (menuClosed)="onMenuClosed()">
    <app-icon icon="ellipsis-v" aria-hidden="true"></app-icon>
    <span class="visually-hidden">{{ node.label }} menu</span>
  </button>

  <!-- Main manu -->
  <mat-menu #nodeActions="matMenu" [overlapTrigger]="true">
    <!-- Select -->
    <ng-container *appFlagApplication="application.All; page: '/edit'; mode: 'include'">
      <button mat-menu-item [matMenuTriggerFor]="selectActions">Select</button>
      <mat-divider></mat-divider>
    </ng-container>

    <!-- Show / Hide -->
    <button
      mat-menu-item
      data-test="nodeActionsHideShow"
      (click)="toggleVisible(node, !node.boolState.shown)">
      {{ node.boolState.shown ? 'Hide' : 'Show' }}
    </button>

    <!-- Isolate -->
    <button mat-menu-item data-test="nodeActionsIsolate" (click)="hideInverse(node)">
      Isolate
    </button>

    <!-- Fade -->
    <mat-divider></mat-divider>
    <button data-test="nodeActionsFadeTrigger" mat-menu-item [matMenuTriggerFor]="fadeActions">
      Fade
    </button>

    <!-- Selectable / Unselectable -->
    <ng-container *appFlagApplication="application.All; mode: 'include'; page: '/edit'">
      <mat-divider></mat-divider>
      <button
        mat-menu-item
        data-test="nodeActionsPickableTrigger"
        [matMenuTriggerFor]="pickableActions">
        Selectable / Unselectable
      </button>
    </ng-container>

    <!-- Fly To -->
    <mat-divider></mat-divider>
    <button mat-menu-item data-test="nodeActionsFlyTo" (click)="flyToNode(node)">Fly To</button>

    <!-- Object Label -->
    <ng-container *appFlagApplication="application.Loft; page: '/edit'; mode: 'include'">
      <mat-divider></mat-divider>
      <button mat-menu-item data-test="nodeActionsEditName" (click)="editNodeLabel(node)">
        Edit Object Name
      </button>
    </ng-container>

    <!-- Copy -->
    <ng-container *appFlagApplication="application.Loft; page: '/edit'; mode: 'include'">
      <mat-divider></mat-divider>
      <button mat-menu-item data-test="nodeActionsCopyTrigger" [matMenuTriggerFor]="copyActions">
        Copy
      </button>
    </ng-container>

    <!-- Eyedropper -->
    <ng-container *appFlagApplication="application.All; page: '/edit'; mode: 'include'">
      <mat-divider></mat-divider>
      <button mat-menu-item data-test="nodeActionsSamplePaint" (click)="samplePaint(node)">
        Sample Paint
      </button>
    </ng-container>
  </mat-menu>

  <!-- Select submenu -->
  <mat-menu #selectActions="matMenu">
    <button mat-menu-item data-test="nodeActionsSelectThis" (click)="checkNode(node, true)">
      Select This
    </button>
    <button mat-menu-item data-test="nodeActionsSelectEverythingElse" (click)="checkInverse(node)">
      Select Everything Else
    </button>
  </mat-menu>

  <!-- Fade submenu -->
  <mat-menu #fadeActions="matMenu">
    <button mat-menu-item data-test="nodeActionsFadeThis" (click)="fadeNode(node)">
      Fade This
    </button>
    <button
      mat-menu-item
      data-test="nodeActionsFadeEverythingElse"
      (click)="fadeInverseNodes(node)">
      Fade Everything Else
    </button>
  </mat-menu>

  <!-- Show / Hide submenu -->
  <mat-menu #showHideActions="matMenu">
    <button
      mat-menu-item
      data-test="nodeActionsShowThis"
      (click)="toggleVisible(node, true)"
      *ngIf="!node.boolState.shown">
      Show This
    </button>
    <button
      mat-menu-item
      data-test="nodeActionsShowEverythingElse"
      (click)="toggleVisible(node, false)"
      *ngIf="node.boolState.shown">
      Hide This
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="hideInverse(node)">Hide Everything Else</button>
  </mat-menu>

  <!-- Pickable submenu -->
  <mat-menu #pickableActions="matMenu">
    <button
      *ngIf="node.boolState.pickable"
      mat-menu-item
      data-test="nodeActionsPickable"
      (click)="togglePickable(node, false)">
      Make Unselectable
    </button>
    <button
      *ngIf="!node.boolState.pickable"
      mat-menu-item
      data-test="nodeActionsUnpickable"
      (click)="togglePickable(node, true)">
      Make Selectable
    </button>
    <mat-divider></mat-divider>
    <button
      mat-menu-item
      data-test="nodeActionsEverythingElseUnpickable"
      (click)="makeEverythingElseUnpickale(node)">
      Make Everything Else Unselectable
    </button>
  </mat-menu>

  <!-- Copy submenu -->
  <mat-menu #copyActions="matMenu">
    <button mat-menu-item data-test="nodeActionsCopyShortID" (click)="copy(shortId)">
      Copy Short ID
    </button>
    <button mat-menu-item data-test="nodeActionsCopyFullID" (click)="copy(node.id)">
      Copy Full ID
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item data-test="nodeActionsCopyDisplayName" (click)="copy(node.label)">
      Copy Display Name
    </button>
  </mat-menu>
</ng-container>
